'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../util/validators/password-validator.js');
require('../util/helpers/strings.js');
require('../util/helpers/date.js');
require('../util/helpers/arrays.js');
require('../util/helpers/language.js');
require('../util/helpers/numbers.js');
require('../util/helpers/currency.js');
require('../util/helpers/dom.js');
require('../util/helpers/debounce.js');
require('../util/helpers/throttle.js');
require('../util/helpers/functions.js');
require('../util/helpers/session.js');
require('../util/helpers/forms.js');
require('../util/helpers/keys.js');
require('../util/helpers/game.js');
require('../util/helpers/game-category.js');
require('../util/helpers/script.js');
require('../util/helpers/events.js');
require('../util/helpers/password.js');
require('../util/helpers/storage.js');
require('../util/helpers/theming.js');
require('../util/helpers/objects.js');
require('../util/helpers/slots.js');
require('../util/helpers/phone.js');
require('../util/validators/date-validator.js');
require('../util/validators/debounce-validator.js');
require('../util/types/input.js');
var device_enum = require('../util/types/device.enum.js');
var magicMessages = require('@gig/magic-messages');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function isBreakpointMobileQuery() {
  return __async(this, null, function* () {
    const device = yield window.queryBus.query(magicMessages.BREAKPOINT_DEVICE_QUERY);
    return isBreakpointMobile(device);
  });
}
function isBreakpointMobileSync() {
  const device = window.eventBus.getLatest(magicMessages.BREAKPOINT_DEVICE_UPDATED);
  return isBreakpointMobile(device);
}
function isBreakpointDesktopQuery() {
  return __async(this, null, function* () {
    const device = yield window.queryBus.query(magicMessages.BREAKPOINT_DEVICE_QUERY);
    return isBreakpointDesktop(device);
  });
}
function isBreakpointDesktopSync() {
  const device = window.eventBus.getLatest(magicMessages.BREAKPOINT_DEVICE_UPDATED);
  return isBreakpointDesktop(device);
}
function isBreakpointMobile(device) {
  return [device_enum.CssDevice.MOBILE, device_enum.CssDevice.PHABLET, device_enum.CssDevice.TABLET].indexOf(device) !== -1;
}
function isBreakpointDesktop(device) {
  return [device_enum.CssDevice.LARGE, device_enum.CssDevice.DESKTOP].indexOf(device) !== -1;
}
function isBreakpointLargeQuery() {
  return __async(this, null, function* () {
    const device = yield window.queryBus.query(magicMessages.BREAKPOINT_DEVICE_QUERY);
    return device === device_enum.CssDevice.LARGE;
  });
}
function isBreakpointLargeSync() {
  const device = window.eventBus.getLatest(magicMessages.BREAKPOINT_DEVICE_UPDATED);
  return device === device_enum.CssDevice.LARGE;
}

exports.isBreakpointDesktopQuery = isBreakpointDesktopQuery;
exports.isBreakpointDesktopSync = isBreakpointDesktopSync;
exports.isBreakpointLargeQuery = isBreakpointLargeQuery;
exports.isBreakpointLargeSync = isBreakpointLargeSync;
exports.isBreakpointMobileQuery = isBreakpointMobileQuery;
exports.isBreakpointMobileSync = isBreakpointMobileSync;
